import React, { useEffect, useState } from 'react';

interface XRSupportProps {
  children: React.ReactNode;
}

const XRSupport: React.FC<XRSupportProps> = ({ children }) => {
  const [isXRSupported, setIsXRSupported] = useState<boolean | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    // Check if WebXR is supported
    if (typeof navigator.xr === 'undefined') {
      setIsXRSupported(false);
      setErrorMessage('WebXR is not supported in your browser. Try using a modern browser like Chrome, Edge, or Firefox.');
      return;
    }

    // Check if WebXR has immersive-vr session support
    navigator.xr.isSessionSupported('immersive-vr')
      .then(supported => {
        setIsXRSupported(supported);
        if (!supported) {
          setErrorMessage('Your browser supports WebXR, but immersive VR sessions are not available. Make sure your VR headset is connected properly.');
        }
      })
      .catch(error => {
        setIsXRSupported(false);
        setErrorMessage(`Error checking WebXR support: ${error.message}`);
      });
  }, []);

  if (isXRSupported === null) {
    return (
      <div className="xr-loading" style={{ height: '100vh', width: '100%' }}>
        <p>Checking WebXR compatibility...</p>
      </div>
    );
  }

  if (!isXRSupported) {
    return (
      <div className="xr-error" style={{ height: '100vh', width: '100%' }}>
        <h2>WebXR Support Limited</h2>
        <p>{errorMessage}</p>
        <div className="xr-fallback" style={{ height: '100vh', width: '100%' }}>
          <p>You can still explore the 3D scene without VR:</p>
          {children}
        </div>
      </div>
    );
  }

  // WebXR is supported, render children in a full-height container
  return <div style={{ height: '100vh', width: '100%' }}>{children}</div>;
};

export default XRSupport; 